module.exports = __webpack_public_path__ + "static/img/wxcode.2c865bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/wxcode.jpg
// module id = oUCx
// module chunks = 1